import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import ajaxPromise from '../utils/ajaxPromise';

export const fetchSearchResults = createAsyncThunk(
  'semanticSearch/fetchSearchResults',
  async (queryObject, thunkAPI) => {
    const response = await ajaxPromise('/api/semantic-search', 'POST', { ...queryObject });
    return response.data;
  },
);

export const fetchRecentSearches = createAsyncThunk(
  'semanticSearch/fetchRecentSearches',
  async (_queryObject, thunkAPI) => {
    const response = await ajaxPromise('/api/recent-semantic-searches', 'GET');
    return response.data;
  },
);

const slice = createSlice({
  name: 'semanticSearch',
  initialState: {
    semanticData: null,
    semanticDataLoaded: false,
    semanticDataLoading: false,
    semanticError: false,
    recentSemanticSearches: [],
  },
  reducers: {
    reset: (state) => {
      state.semanticData = null;
      state.semanticDataLoaded = false;
      state.semanticDataLoading = false;
      state.semanticError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSearchResults.fulfilled, (state, action) => {
      state.semanticDataLoaded = true;
      state.semanticDataLoading = false;
      state.semanticData = action.payload;
    });
    builder.addCase(fetchSearchResults.pending, (state) => {
      state.semanticDataLoaded = false;
      state.semanticDataLoading = true;
    });
    builder.addCase(fetchSearchResults.rejected, (state) => {
      state.semanticDataLoaded = false;
      state.semanticDataLoading = false;
      state.semanticData = null;
      state.semanticError = true;
    });
    builder.addCase(fetchRecentSearches.fulfilled, (state, action) => {
      state.recentSemanticSearches = action.payload;
    });
  },
});
export default slice.reducer;

export const semanticSearchActions = { ...slice.actions };
